import { combineReducers } from "redux";
import login from "../reducer/login";

const rootReducer = combineReducers({
  login
});

export default rootReducer;
